define('viewmodels/configuration/UserRole',['plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'services/utils'],
    function (router, appsecurity, navigation, app, system, logger, utils) {
        var UrViewModel = {
            activate: activate,
            attached: attached,
            appsecurity: appsecurity,

            UserDetailsList: ko.observableArray(),
            UserDetailsListDup: ko.observableArray(),
            AssessmentPeriodsList: ko.observableArray(),
            SelectedAssessmentPeriodMultiType: ko.observableArray(),
            SelectedAssessmentPeiodType: ko.observable(),
            APNameObservable: ko.observable(),
            RoleListOriginalForPrimary: ko.observableArray(),
            RoleListOriginalForSecondary: ko.observableArray(),
            UserDetails: ko.observable(),
            ViewUserDetails: ViewUserDetails,
            OnSubmitclick: OnSubmitclick,
            ViewUserDetailsName: ko.observable(false),
            EditUserDetails: ko.observable(false),
            ManageUserActions: ManageUserActions,
            ManagementActionFlag: ko.observable(false),
            AddUserFlag: ko.observable(false),
            onChnageofUserGroups: onChnageofUserGroups,
            AddUserGroupFlag: ko.observable(false),
            Usergroupselectlabel: ko.observable(),
            BusinessLevelList: ko.observableArray(),
            UserGroupDetails: ko.observable(),
            BusinessLevelValueList: ko.observableArray(),
            BusinessDivisionDrpDwnList: ko.observableArray(),
            ViewUserGroupDetailsList: ko.observableArray([]),
            LegalEntityDrpDwnList: ko.observableArray(),
            RegionsList: ko.observableArray(),
            CountriesList: ko.observableArray(),
            CancelUserDetailsPopup: CancelUserDetailsPopup,
            ClickEditUserDetails: ClickEditUserDetails,
            IseditUserName: ko.observable(false),
            ViewUserDetailsPopUpTitle: ko.observable(),
            ViewUserGroupDetailsPopUpTitle: ko.observable(),
            PrimaryRoleDrpDwnList: ko.observableArray(),
            PrimaryRoleDrpDwnChange: PrimaryRoleDrpDwnChange,
            OpenSelectFilePopUp: OpenSelectFilePopUp,
            SaveUserDetails: SaveUserDetails,
            ActionChanged: ActionChanged,
            ManageUserActionsFlag: ko.observable(false),
            popUpTitle: ko.observable(),
            NameCharLimit: ko.observable(250),
            EMailValidationRegEx: ko.observable("/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/"),
            ClickAddUser: ClickAddUser,
            ClickAddUserGroup: ClickAddUserGroup,
            BulkActionsList: ko.observableArray(["----Select an Action for Selected Users----", "Activate Users", "Deactivate Users", "Lock Users", "Unlock Users", "Reset Password for Users"]),
            ActionsMasterList: ko.observableArray(["----Select an Action for this User----", "Activate This User", "Deactivate This User", "Lock This User", "Unlock This User", "Reset Password for this User", "Assign/Unassign user group"]),
            ActionsList: ko.observableArray(),
            SelectedActionValue: ko.observable("----Select an Action for this User----"),
            PerformUserAction: PerformUserAction,
            uploadBulkUserTemplate: uploadBulkUserTemplate,
            YearofAssessment: ko.observable(),
            viewUserGroupDetails: viewUserGroupDetails,
            downloadBulkUploadTemplate: function () {
                var payload = {
                    t: appsecurity.getAuthenticationInfo()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/BulkUserCreationTemplate", payload, '_blank');
            },
            successfullyCreatedUserList: ko.observableArray(),
            AddUserGroup: AddUserGroup,
            ConfigurationLevelList: ko.observableArray(),
            SelectedOrganisationLevel: ko.observableArray([]),
            UserGroupList: ko.observableArray([]),
            SelectedUserGroups: ko.observableArray([]),
            OnLockUsersClick: OnLockUsersClick,
            OnResetPasswordClick: OnResetPasswordClick,
            OnDeactivateClick: OnDeactivateClick,
            OnUnLockUsersClick: OnUnLockUsersClick,
            SelectAll: SelectAll,
            SelectedUserList: ko.observableArray(),
            BulkUserActions: BulkUserActions,
            PerformBulkAction: PerformBulkAction,
            SelectedAction: ko.observable(),
            MobileNumber: ko.observable(),
            ChangedSSO: ChangedSSO,
            IsSSOUser: ko.observable(false),
            IsADUser: ko.observable(false),
            ApplicableGroups: ko.observableArray(),
        };
        return UrViewModel;

        var UserTableObj = false;

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.BlId = ko.observable($('<div/>').html(item.BlId).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlDescription = ko.observable($('<div/>').html(item.BlDescription).text());
                self.BlShortName = ko.observable($('<div/>').html(item.BlShortName).text());
                self.Flag = ko.observable(item.Flag);
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.TargetRow = ko.observable();
                if (item.BuLevelValueList != undefined) {
                    var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                        return new BuLevelValueListModel(result);
                    });
                    self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }


        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function activate() {
            try {

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                $('#LoadingImgDivUser').show();
                $('#UserRoleTable').hide();
                $('#error').hide();

                GetUserDetails();
                GetActiveRoles().then(function () {
                    GetSurveyRoles();
                });
                //usergroup commented as this needs to be in sync with assessment period
                //GetUserGroups();
                GetAssessmentPeriodDetails();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function BulkUserActions(data, event) {
            try {
                var checkboxs = document.getElementsByName("c1");
                var okay = false;
                for (var i = 0, l = checkboxs.length; i < l; i++) {
                    if (checkboxs[i].checked) {
                        okay = true;
                        break;
                    }
                }
                if (okay) {
                    $('#validationError').hide();
                    $('#frmBulkOperations').modal('show');
                }
                else {
                    logger.logError('Please select Users to perform action.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }
            catch (e) {

            }
        }

        function PerformBulkAction(data, event) {
            try {
                $('#validationError').hide();
                if (UrViewModel.BulkActionsList.indexOf(UrViewModel.SelectedAction()) == 0) {
                    $('#validationError').text("Please select an action to perform.");
                    $('#validationError').show();
                }
                else if (UrViewModel.BulkActionsList.indexOf(UrViewModel.SelectedAction()) == 1)
                    OnSubmitclick(data, event);//actiavte users
                else if (UrViewModel.BulkActionsList.indexOf(UrViewModel.SelectedAction()) == 2)
                    OnDeactivateClick(data, event);//Deactivateusers
                else if (UrViewModel.BulkActionsList.indexOf(UrViewModel.SelectedAction()) == 3)
                    OnLockUsersClick(data, event);//lockusers
                else if (UrViewModel.BulkActionsList.indexOf(UrViewModel.SelectedAction()) == 4)
                    OnUnLockUsersClick(data, event);//unlockusers
                else if (UrViewModel.BulkActionsList.indexOf(UrViewModel.SelectedAction()) == 5)
                    OnResetPasswordClick(data, event);//resetpassword
            }
            catch (e) {

            }
        }

        //--------------------------------------------------------------- Logic for selecting all users ------------------------------------------------------------
        function SelectAll(data, event) {
            try {
                for (var i = 0; i < data.UserDetailsList().length; i++) {
                    if (event.currentTarget.checked == true) {
                        data.UserDetailsList()[i].IsSelected(true);
                    }
                    else {
                        $('#selectall').prop("checked", false);
                        data.UserDetailsList()[i].IsSelected(false);
                    }
                }
                var rows = $("#UserRoleTable").dataTable().fnGetNodes();
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    if (event.currentTarget.checked == true)
                        $(rows[i]).find("td:eq(9)").find('input').prop("checked", true);
                    else
                        $(rows[i]).find("td:eq(9)").find('input').prop("checked", false);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAll() method in UserRole.js';
                logger.logMessage(msg);
            }
        }


        //------------------------------------------------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------

        function GetAssessmentPeriodDetails() {
            try {
                $.ajax({
                    url: "/api/Calculation/GetProfileAssessmentData",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAssessmentPeriodDetails() method in UserRole.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, error) {
                try {

                    if (jsonResult != null) {
                        var mappedAProfileDetails = $.map(jsonResult, function (result) {
                            return new AssessmentPeriodModel(result);
                        });
                        UrViewModel.AssessmentPeriodsList(mappedAProfileDetails);
                    }
                    else
                        logger.logError('An error occurred while fetching User details.', 'Error', system.getModuleId(UrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAssessmentPeriodDetails() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUserDetails() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg2 = 'Exception: ' + e + ' | Source: ajaxFail in GetAssessmentPeriodDetails() method in UserRole.js';
                    logger.logMessage(msg2);
                }
            };
        }
        function GetUserDetails() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetAllUserDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUserDetails() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    var table = $("#UserRoleTable").dataTable();
                    table.fnDestroy();
                    $("#UserRoleTable tbody tr").remove();
                    $('#LoadingImgDivUser').hide();
                    $('#div_UserRoleTable').show();
                    $('#UserRoleTable').show();

                    if (jsonResult != null) {
                        var mappedUserDetails = $.map(jsonResult, function (result) {
                            return new UserDetailsModel(result);
                        });
                        UrViewModel.UserDetailsList(mappedUserDetails);
                        var mappedUserDetailsDup = $.map(jsonResult, function (result) {
                            return new UserDetailsModel(result);
                        });
                        UrViewModel.UserDetailsListDup(mappedUserDetails);
                        UserTableObj = $('#UserRoleTable').DataTable(
                            {
                                "stateSave": true,
                                "ordering": true,
                                "responsive": true,
                                "columnDefs": [{
                                    "targets": [0],
                                    "visible": false,
                                    "orderable": false
                                }, {
                                    "targets": [1],
                                    "orderable": false
                                }]
                            });
                        UserTableObj.column(8).visible(!UrViewModel.appsecurity.WriteAccess());
                        UserTableObj.column(9).visible(UrViewModel.appsecurity.WriteAccess());
                    }
                    else
                        logger.logError('An error occurred while fetching User details.', 'Error', system.getModuleId(UrViewModel), true);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUserDetails() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUserDetails() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUserDetails() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetActiveRoles() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetActiveRoles",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetActiveRoles() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {
                        var mappedUserDetails = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });
                        UrViewModel.RoleListOriginalForPrimary(mappedUserDetails);

                        var mappedPrimaryRole = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });
                        UrViewModel.PrimaryRoleDrpDwnList(mappedPrimaryRole);

                        var mappedSecondaryRole = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });

                    }
                    else
                        logger.logError('An error occurred while fetching Active Roles.', 'Error', system.getModuleId(UrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetActiveRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetActiveRoles() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetActiveRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetSurveyRoles() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetSurveyRoles",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetSurveyRoles() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null) {
                        var MappedL1List = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });
                        var MappedSecondaryList = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        });
                        UrViewModel.RoleListOriginalForSecondary(MappedSecondaryList);
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }

            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyRoles() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }
        }


        //------------------------------------------------------------------------Logic to Fetch User Details and List of All Roles Ends Here----------------------------------------------

        //------------------------------------------------------------------------Logic to View User Details Starts Here--------------------------------------------------------------------
        function ViewUserDetails(data, event) {
            try {
                UrViewModel.ViewUserDetailsName(true);
                UrViewModel.ManageUserActionsFlag(false);
                UrViewModel.Usergroupselectlabel("User Groups Assigned:")
                var LastLoginDate = data.LastLoginDate();
                UrViewModel.SelectedUserGroups(data.UserGroupIdList())
                data = SyncUserDetails(data);
                (data.PrimaryRoleId() == 0) ? data.PrimaryRoleName("Not Applicable") : data.PrimaryRoleName();
                (data.SecondaryRoleId() == 0) ? data.SecondaryRoleName("Not Applicable") : data.SecondaryRoleName();
                (data.APId() == null) ? data.APName("Not Applicable") : data.APName();
                data.LastLoginDate(LastLoginDate);
                UrViewModel.UserDetails(data);
                UrViewModel.EditUserDetails(false);
                UrViewModel.ManagementActionFlag(false);
                UrViewModel.AddUserFlag(false);
                var labeltext = "";
                if (UrViewModel.SelectedUserGroups() != null) {
                    for (var k = 0; k < UrViewModel.SelectedUserGroups().length; k++) {
                        for (var i = 0; i < UrViewModel.UserGroupList().length; i++) {
                            if (UrViewModel.UserGroupList()[i].UserGroupId == UrViewModel.SelectedUserGroups()[k]) {
                                labeltext = labeltext + UrViewModel.UserGroupList()[i].UserGroupName + ' </br> ';
                                break;
                            }
                        }
                    }
                    $('#labelSelectedUserGroup').html(labeltext);
                    $('#ViewuserGroupDetailsId').show();
                }
                else {
                    $('#ViewuserGroupDetailsId').hide();
                }
                $('#HeaderIcon').removeClass();
                $('#HeaderIcon').addClass('title-icon col-md-1 fa fa-eye');
                UrViewModel.ViewUserDetailsPopUpTitle('User Detail - ' + data.UserName());
                $('#frmUserDetails').modal('show');
                setTimeout("$('#UserGroup').multiselect()", 200);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewUserDetails() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function SyncUserDetails(result) {
            try {
                return mappedUserDetail = new UserDetailsModel({
                    UserId: result.UserId(),
                    UserName: result.UserName(),
                    FirstName: result.FirstName(),
                    LastName: result.LastName(),
                    MobileNumber: result.MobileNumber(),
                    EMailId: result.EMailId(),
                    LastLoginDate: result.LastLoginDate(),
                    PrimaryRoleId: result.PrimaryRoleId(),
                    PrimaryRoleName: result.PrimaryRoleName(),
                    SecondaryRoleId: result.SecondaryRoleId(),
                    SecondaryRoleName: result.SecondaryRoleName(),
                    APId: result.APId(),
                    APName: result.APName(),
                    IsActive: result.IsActive(),
                    IsLocked: result.IsLocked(),
                    IsSSOUser: result.IsSSOUser(),
                    IsADUser: result.IsADUser(),
                    IsSSOUsertext: result.IsSSOUser() == true ? 'Yes' : 'No',
                    UserGroupIdList: result.UserGroupIdList()
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SyncUserDetails() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        //------------------------------------------------------------------------Logic to View User Details Starts Here----------------------------------------------------------------------

        //------------------------------------------------------------------------Logic to Edit User Details Starts Here----------------------------------------------------------------------
        function ClickEditUserDetails(data, event) {
            try {
                //GetUserGroupsforUser(data.UserId()).then(function () {


                UrViewModel.ViewUserDetailsName(false);
                data = SyncUserDetails(data);
                if (data.MobileNumber().toLowerCase() == 'not available') {
                    data.MobileNumber("");
                }
                SyncDrpDwnList("Both");
                UrViewModel.IseditUserName(true);
                UrViewModel.UserDetails(data);
                var DuplicateIndex = 0;
                UrViewModel.SelectedAssessmentPeriodMultiType([]);
                var assignedAPD = data.APId().toString().split(',');
                var selectedAPD = [];
                for (var i = 0; i < assignedAPD.length; i++) {
                    if (!isNaN(assignedAPD[i]))
                        selectedAPD.push(parseInt(assignedAPD[i].toString().trim()));
                }
                UrViewModel.SelectedAssessmentPeriodMultiType(selectedAPD);
                UrViewModel.EditUserDetails(true);
                UrViewModel.ManagementActionFlag(false);
                UrViewModel.AddUserFlag(true);

                if (data.IsSSOUser() == false && data.IsADUser() == false) {
                    $("#NoChkFactor").prop("checked", true);
                    $("#YesChkFactor").prop("checked", false);
                    $("#YesADFactor").prop("checked", false);

                }
                else if (data.IsSSOUser() == true && data.IsADUser() == false) {
                    $("#NoChkFactor").prop("checked", false);
                    $("#YesChkFactor").prop("checked", true);
                    $("#YesADFactor").prop("checked", false);

                } else if (data.IsADUser() == true) {
                    $("#NoChkFactor").prop("checked", false);
                    $("#YesChkFactor").prop("checked", false);
                    $("#YesADFactor").prop("checked", true);
                }
                UrViewModel.IsSSOUser(data.IsSSOUser());
                UrViewModel.IsADUser(data.IsADUser());

                $('#HeaderIcon').removeClass();
                $('#HeaderIcon').addClass('title-icon col-md-1 fa fa-edit');
                UrViewModel.ViewUserDetailsPopUpTitle('Edit User Detail - ' + data.UserName());
                UrViewModel.ManageUserActionsFlag(false);

                //var selectedUG = [];
                //if (data.UserGroups() != undefined) {
                //    if (data.UserGroups().length > 0 && data.UserGroups()[0].mappedIdList() != undefined) {
                //        if (data.UserGroups()[0].mappedIdList().length > 0) {
                //            for (var i = 0; i < data.UserGroups()[0].mappedIdList().length; i++) {
                //                if (data.UserGroups()[0].mappedIdList()[i].UserId == data.UserId())
                //                    selectedUG.push(parseInt(data.UserGroups()[0].mappedIdList()[i].UserGroupId));
                //            }
                //        }
                //    }
                //}


                UrViewModel.SelectedUserGroups(UrViewModel.ApplicableGroups());
                $('#frmUserDetails').modal('show');
                $("#usernumberadd").intlTelInput({
                    allowExtensions: true,
                    autoFormat: false,
                    autoHideDialCode: false,
                    autoPlaceholder: false,
                    defaultCountry: "auto",
                    ipinfoToken: "yolo",
                    nationalMode: false,
                    numberType: "MOBILE",
                    preventInvalidNumbers: true,
                });
                var splitID = $.map(data.APId().split(","), $.trim);
                $("#AssessmentPeriodMultiSelect").multiselect();
                $("#AssessmentPeriodMultiSelect").val(splitID);
                $("#AssessmentPeriodMultiSelect").multiselect('refresh');
                $('#UserGroup').multiselect();
                $("#UserGroup").multiselect('refresh');
                // });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClickEditUserDetails() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function SyncDrpDwnList(Type) {
            try {
                if (Type == "Primary") {
                    var mappedPrimaryList = $.map(UrViewModel.RoleListOriginalForPrimary(), function (result) {
                        return new RoleModel({ RoleId: result.RoleId(), RoleName: result.RoleName() });
                    });
                    UrViewModel.PrimaryRoleDrpDwnList(mappedPrimaryList);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SyncDrpDwnList() method in UserRole.js';
                logger.logMessage(msg);
            }
        }



        function PrimaryRoleDrpDwnChange(data, event) {
            try {

                SyncDrpDwnList("Secondary");
                var DuplicateIndex = -1;
                var DefaultRoleId = UrViewModel.RoleListOriginalForPrimary()[0].RoleId();
                if (event.currentTarget.value != DefaultRoleId) {
                    if (event.currentTarget.value == data.SecondaryRoleId())
                        data.SecondaryRoleId(DefaultRoleId);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PrimaryRoleDrpDwnChange() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function SaveUserDetails(data, event) {
            try {
                for (var i = 0; i < UrViewModel.RoleListOriginalForPrimary().length; i++) {
                    if (data.PrimaryRoleId() == UrViewModel.RoleListOriginalForPrimary()[i].RoleId()) {
                        var RoleName = UrViewModel.RoleListOriginalForPrimary()[i].RoleName();
                        data.PrimaryRoleName(RoleName);
                    }
                }
                for (var i = 0; i < UrViewModel.RoleListOriginalForSecondary().length; i++) {
                    if (data.SecondaryRoleId() == UrViewModel.RoleListOriginalForSecondary()[i].RoleId()) {
                        var RoleName = UrViewModel.RoleListOriginalForSecondary()[i].RoleName();
                        data.SecondaryRoleName(RoleName);
                    }
                }
                UrViewModel.APNameObservable("");
                var APName = "";
                for (var i = 0; i < UrViewModel.SelectedAssessmentPeriodMultiType().length; i++) {
                    if (APName == "") {
                        APName = UrViewModel.SelectedAssessmentPeriodMultiType()[i];
                    } else {
                        APName += "," + UrViewModel.SelectedAssessmentPeriodMultiType()[i];
                    }
                }
                UrViewModel.APNameObservable(APName);
                if (ValidateUserValues(data, event)) {

                    //if (UrViewModel.SelectedUserGroups() != null) {
                    //    AssignUnassignUserGroups(data, event);
                    //}

                    if (document.getElementById('btnAddUpdate').innerText.trim() == "Update")
                        UpdateUserDetails(data, event);
                    else if (document.getElementById('btnAddUpdate').innerText.trim() == "Create")
                        AddUser(data);

                    $('#frmUserDetails').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveUserDetails() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function ValidateUserValues(data, event) {
            try {
                var DuplicateMailCount = 0;
                var Validated = false;
                $('#valError').text("");
                $('#valError').show();
                for (var i = 0; i < UrViewModel.UserDetailsList().length; i++) {
                    if ((UrViewModel.UserDetailsList()[i].EMailId() == data.EMailId() && UrViewModel.UserDetailsList()[i].UserId() != data.UserId())) {
                        DuplicateMailCount++;
                    }

                    if (data.EMailId() == appsecurity.EmailId()) {
                        DuplicateMailCount++;
                    }
                }
                if (data.UserName() == "")
                    $('#valError').text("User Name cannot be left blank.");
                else if (data.UserName().length > UrViewModel.NameCharLimit())
                    $('#valError').text("User Name cannot be mosre than " + UrViewModel.NameCharLimit() + " characters.");
                else if (data.FirstName() == "")
                    $('#valError').text("First Name cannot be left blank.");
                else if (data.FirstName().length > UrViewModel.NameCharLimit())
                    $('#valError').text("First Name cannot be more than " + UrViewModel.NameCharLimit() + " characters.");
                else if (data.LastName() == "")
                    $('#valError').text("Last Name cannot be left blank.");
                else if (data.LastName().length > UrViewModel.NameCharLimit())
                    $('#valError').text("Last Name cannot be more than " + UrViewModel.NameCharLimit() + " characters.");
                else if (data.EMailId() == "")
                    $('#valError').text("E-mail cannot be left blank.");
                else if (data.LastName().length > UrViewModel.NameCharLimit())
                    $('#valError').text("Last Name cannot be more than " + UrViewModel.NameCharLimit() + " characters.");
                else if (!(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(data.EMailId()))
                    $('#valError').text("E-mail ID not in valid format.");
                else if (data.PrimaryRoleId() == UrViewModel.RoleListOriginalForPrimary()[0].RoleId())
                    $('#valError').text("User should have a Primary Role.");
                else if (DuplicateMailCount > 0) {
                    $('#valError').show();
                    $('#valError').text("Entered E-mail ID already exists.");
                }
                else if (!$("#usernumberadd").intlTelInput("isValidNumber")) {
                    var Countrycode = "+" + $("#usernumberadd").intlTelInput("getSelectedCountryData").dialCode;
                    var number = $("#usernumberadd").intlTelInput("getNumber");
                    number = number.substring(Countrycode.length, number.length);
                    if (number.length == 0) {

                        Validated = true;
                    }
                    else {

                        $('#valError').show();
                        $('#valError').text("Enter valid Phone Number.");
                    }

                }
                else {
                    Validated = true;
                    $('#valError').text("");
                }
                return Validated;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateUserValues() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function UpdateUserDetails(data, event) {
            try {

                var Countrycode = "+" + $("#usernumberadd").intlTelInput("getSelectedCountryData").dialCode;
                var number = $("#usernumberadd").intlTelInput("getNumber");
                number = number.substring(Countrycode.length, number.length)
                if (number.length != 0) {
                    data.MobileNumber(Countrycode + "-" + number);
                }
                else {
                    data.MobileNumber("");
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                if (data.IsActive() === true)
                    data.IsActive(1);
                else data.IsActive(0);
                if (data.IsLocked() === true)
                    data.IsLocked(1);
                else data.IsLocked(0);
                var userType = 0;
                if (UrViewModel.IsSSOUser() == false && UrViewModel.IsADUser() == false) {
                    userType = 0;
                }
                else if (UrViewModel.IsSSOUser() == true && UrViewModel.IsADUser() == false) {
                    userType = 1;
                } else if (UrViewModel.IsSSOUser() == false && UrViewModel.IsADUser() == true) {
                    userType = 2;
                }

                $.ajax({
                    url: "/api/Account/UpdateUser",
                    type: "POST",
                    headers: headers,
                    data: ({
                        UserName: data.UserName(),
                        FirstName: data.FirstName(),
                        LastName: data.LastName(),
                        EMail: data.EMailId(),
                        APName: UrViewModel.APNameObservable(),
                        MobileNumber: data.MobileNumber(),
                        PrimaryRoleID: data.PrimaryRoleId(),
                        SecondaryRoleID: data.SecondaryRoleId(),
                        IsUserActive: data.IsActive(),
                        IsUserLocked: data.IsLocked(),
                        UserGroupList: data.SelectedUserGroups(),
                        IsSSOUser: UrViewModel.IsSSOUser(),
                        IsADUser: UrViewModel.IsADUser(),
                        UserType: userType
                    })
                })
                    .success(function (message) {
                        GetUserDetails();
                        if (message == "Modified User details successfully but Assessment Period details could not be updated.")
                            logger.logWarning('Modified User details successfully but Assessment Period details could not be updated.', 'Warning', system.getModuleId(UrViewModel), true);
                        else
                            logger.logSuccess('User details updated successfully.', 'Success', system.getModuleId(UrViewModel), true);
                    })
                    .fail(function (message) {
                        logger.logError(message.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateUserDetails() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        //------------------------------------------------------------------------Logic to Edit User Details Ends Here----------------------------------------------------------------------
        //-------------------------------------------------------------------------------Logic to handle submit on click starts here-----------------------------------------------------------------------



        function OnSubmitclick(data, event) {
            try {

                UrViewModel.SelectedUserList($.map(UrViewModel.UserDetailsList(), function (result) {
                    if (result.IsSelected()) {
                        return { UserId: result.UserId(), UserName: result.UserName(), Status: result.Status() }
                    }
                }));
                var allUserDeactivate = true;
                UrViewModel.SelectedUserList().forEach(function (data, i) {
                    if (data.Status == "Active")
                        allUserDeactivate = false;
                });

                $('#error').hide();
                var checkboxs = document.getElementsByName("c1");
                var okay = false;
                for (var i = 0, l = checkboxs.length; i < l; i++) {
                    if (checkboxs[i].checked) {
                        okay = true;
                        break;
                    }
                }
                if (okay) {
                    if (allUserDeactivate) {
                        app.showMessage("Are you sure you want to activate the selected Users?", "Activate Users", ['Confirm', 'Cancel'], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "Confirm") {
                                    $('#frmBulkOperations').modal('hide');
                                    $('#LoadingImgDivUser').show();
                                    $('#div_UserRoleTable').hide();
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    $.ajax({
                                        url: "/api/Account/ActivateAllUsers",
                                        type: "POST",
                                        headers: headers,
                                        contentType: 'application/json',

                                        data: JSON.stringify($.map(UrViewModel.UserDetailsList(), function (result) {

                                            if (result.IsSelected()) {
                                                return { UserId: result.UserId(), UserName: result.UserName() }
                                            }

                                        }))

                                    })
                                        .success(function (jsonResult) {
                                            $('#LoadingImgDivUser').hide();
                                            if (jsonResult != null) {
                                                GetUserDetails();
                                                logger.logSuccess('Users are activated successfully.', 'Success', system.getModuleId(UrViewModel), true);
                                            }
                                            else {
                                                logger.logError(jsonResult.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                                            }
                                        })
                                        .fail(function (error) {
                                            try {
                                                $('#LoadingImgDivUser').hide();
                                                if (error.status == 401) {
                                                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                                        .then(function (option) {
                                                            if (option == "OK")
                                                                navigation.unauthorized();

                                                        })
                                                }
                                                else {
                                                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in OnSubmitClick() method in UserRole.js';
                                                    logger.logMessage(msg);
                                                }
                                            }
                                            catch (e) {
                                                var msg = 'Exception: ' + e + ' | Source: ajaxFail in OnSubmitClick() method in UserRole.js';
                                                logger.logMessage(msg);
                                            }
                                        });
                                }
                            })
                    }
                    else
                        logger.logError('Select only inactive users.', 'Error', system.getModuleId(UrViewModel), true);
                }
                else {
                    $('#error').show();
                    logger.logError('Select users to activate.', 'Error', system.getModuleId(UrViewModel), true);
                }

            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in AddUser() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                $('#LoadingImgDivUser').hide();
                if (jsonResult != null) {
                    GetUserDetails();
                    logger.logSuccess('Users are activated successfully.', 'Success', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError(jsonResult.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }

            function ajaxFail(error, status) {

                try {
                    $('#LoadingImgDivUser').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in OnSubmitClick() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in OnSubmitClick() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };
        }

        //-------------------------------------------------------------------------------Logic to handle submit on click ends  here---------------------------------------------------------------------

        //--------------------------------------------------------------------------- Logic for Bulk operation (Lock, Reset, Deactivate) ---------------------------------------------------------------

        function OnUnLockUsersClick(data, event) {

            try {
                UrViewModel.SelectedUserList($.map(UrViewModel.UserDetailsList(), function (result) {
                    if (result.IsSelected()) {
                        return { UserId: result.UserId(), UserName: result.UserName(), Status: result.Status() }
                    }
                }));
                var allUserlocked = true;
                UrViewModel.SelectedUserList().forEach(function (data, i) {
                    if (data.Status == "Active" || data.Status == "Inactive")
                        allUserlocked = false;
                });
                $('#error').hide();
                var checkboxs = document.getElementsByName("c1");
                var okay = false;
                for (var i = 0, l = checkboxs.length; i < l; i++) {
                    if (checkboxs[i].checked) {
                        okay = true;
                        break;
                    }
                }
                if (okay) {
                    if (allUserlocked) {
                        app.showMessage("Are you sure you want to unlock accounts of the selected Users?", "Unlock Users", ['Confirm', 'Cancel'], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "Confirm") {
                                    $('#frmBulkOperations').modal('hide');
                                    $('#LoadingImgDivUser').show();
                                    $('#div_UserRoleTable').hide();
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    $.ajax({
                                        url: "/api/Account/UnLockAllUsers",
                                        type: "POST",
                                        headers: headers,
                                        contentType: 'application/json',

                                        data: JSON.stringify($.map(UrViewModel.UserDetailsList(), function (result) {

                                            if (result.IsSelected()) {
                                                return { UserId: result.UserId(), UserName: result.UserName() }
                                            }

                                        }))

                                    })
                                        .success(ajaxSuccess)
                                        .fail(ajaxFail);
                                }
                            })
                    }
                    else
                        logger.logError('Select only locked users.', 'Error', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('Please select Users to perform action.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OnLockUsersClick() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    GetUserDetails();
                    logger.logSuccess('Users are unlocked successfully.', 'Success', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in OnUnLockUsersClick() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in OnUnLockUsersClick() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };

        }

        function OnLockUsersClick(data, event) {

            try {
                UrViewModel.SelectedUserList($.map(UrViewModel.UserDetailsList(), function (result) {
                    if (result.IsSelected()) {
                        return { UserId: result.UserId(), UserName: result.UserName(), Status: result.Status() }
                    }
                }));
                var allUserUnlocked = true;
                UrViewModel.SelectedUserList().forEach(function (data, i) {
                    if (data.Status == "Locked" || data.Status == "Inactive")
                        allUserUnlocked = false;
                });
                $('#error').hide();
                var checkboxs = document.getElementsByName("c1");
                var okay = false;
                for (var i = 0, l = checkboxs.length; i < l; i++) {
                    if (checkboxs[i].checked) {
                        okay = true;
                        break;
                    }
                }
                if (okay) {
                    if (allUserUnlocked) {
                        app.showMessage("Are you sure you want to lock accounts of the selected Users?", "Lock Users", ['Confirm', 'Cancel'], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "Confirm") {
                                    $('#frmBulkOperations').modal('hide');
                                    $('#LoadingImgDivUser').show();
                                    $('#div_UserRoleTable').hide();
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    $.ajax({
                                        url: "/api/Account/LockAllUsers",
                                        type: "POST",
                                        headers: headers,
                                        contentType: 'application/json',

                                        data: JSON.stringify($.map(UrViewModel.UserDetailsList(), function (result) {

                                            if (result.IsSelected()) {
                                                return { UserId: result.UserId(), UserName: result.UserName() }
                                            }

                                        }))

                                    })
                                        .success(ajaxSuccess)
                                        .fail(ajaxFail);
                                }
                            })
                    }
                    else
                        logger.logError('Select only active users.', 'Error', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('Please select Users to perform action.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OnLockUsersClick() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    GetUserDetails();
                    logger.logSuccess('Users are locked successfully.', 'Success', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in OnLockUsersClick() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in OnLockUsersClick() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };

        }

        function OnResetPasswordClick(data, event) {

            try {

                UrViewModel.SelectedUserList($.map(UrViewModel.UserDetailsList(), function (result) {
                    if (result.IsSelected()) {
                        return { UserId: result.UserId(), UserName: result.UserName(), Status: result.Status() }
                    }
                }));
                var allUserActive = true;
                UrViewModel.SelectedUserList().forEach(function (data, i) {
                    if (data.Status == "Inactive")
                        allUserActive = false;
                });

                $('#error').hide();
                var checkboxs = document.getElementsByName("c1");
                var okay = false;
                for (var i = 0, l = checkboxs.length; i < l; i++) {
                    if (checkboxs[i].checked) {
                        okay = true;
                        break;
                    }
                }
                if (okay) {
                    if (allUserActive) {
                        app.showMessage("Are you sure you want to Reset Password for the selected Users?", "Reset Password", ['Confirm', 'Cancel'], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "Confirm") {
                                    $('#frmBulkOperations').modal('hide');
                                    $('#LoadingImgDivUser').show();
                                    $('#div_UserRoleTable').hide();
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    $.ajax({
                                        url: "/api/Account/ResetPasswordAllUsers",
                                        type: "POST",
                                        headers: headers,
                                        contentType: 'application/json',

                                        data: JSON.stringify($.map(UrViewModel.UserDetailsList(), function (result) {

                                            if (result.IsSelected()) {
                                                return { UserId: result.UserId(), UserName: result.UserName() }
                                            }

                                        }))

                                    })
                                        .success(ajaxSuccess)
                                        .fail(ajaxFail);
                                }
                            })
                    }
                    else
                        logger.logError('Please select active/locked users for reset password.', 'Error', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('Please select Users to perform action.', 'Error', system.getModuleId(UrViewModel), true);
                }


            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OnLockUsersClick() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    GetUserDetails();
                    logger.logSuccess('Password has been reset for Users successfully.', 'Success', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in OnLockUsersClick() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in OnLockUsersClick() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };

        }

        function OnDeactivateClick(data, event) {
            try {
                UrViewModel.SelectedUserList($.map(UrViewModel.UserDetailsList(), function (result) {
                    if (result.IsSelected()) {
                        return { UserId: result.UserId(), UserName: result.UserName(), Status: result.Status() }
                    }
                }));
                var allUserActivate = false;
                UrViewModel.SelectedUserList().forEach(function (data, i) {
                    if (data.Status == "Inactive")
                        allUserActivate = true;
                });
                $('#error').hide();
                var checkboxs = document.getElementsByName("c1");
                var okay = false;
                for (var i = 0, l = checkboxs.length; i < l; i++) {
                    if (checkboxs[i].checked) {
                        okay = true;
                        break;
                    }
                }
                if (okay) {
                    if (!allUserActivate) {
                        app.showMessage("Are you sure you want to deactivate selected Users?", "Deactivate Users", ['Confirm', 'Cancel'], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "Confirm") {
                                    $('#frmBulkOperations').modal('hide');
                                    $('#LoadingImgDivUser').show();
                                    $('#div_UserRoleTable').hide();
                                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                    var headers = appsecurity.getSecurityHeaders();
                                    headers.__RequestVerificationToken = csrfToken;
                                    $.ajax({
                                        url: "/api/Account/DeactivateAllUsers",
                                        type: "POST",
                                        headers: headers,
                                        contentType: 'application/json',

                                        data: JSON.stringify($.map(UrViewModel.UserDetailsList(), function (result) {

                                            if (result.IsSelected()) {
                                                return { UserId: result.UserId(), UserName: result.UserName() }
                                            }

                                        }))

                                    })
                                        .success(ajaxSuccess)
                                        .fail(ajaxFail);
                                }
                            })
                    }
                    else
                        logger.logError('Select only Active/Locked users.', 'Error', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('Please select Users to perform action.', 'Error', system.getModuleId(UrViewModel), true);
                }

            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OnLockUsersClick() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    GetUserDetails();
                    logger.logSuccess('Users are deactivated successfully.', 'Success', system.getModuleId(UrViewModel), true);
                }
                else {
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in OnLockUsersClick() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in OnLockUsersClick() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };

        }

        //---------------------------------------------------------------------------- Logic Ends here -------------------------------------------------------------------------------------------------


        //------------------------------------------------------------------------Logic to Add User Details Starts Here----------------------------------------------------------------------
        function ClickAddUser(data, event) {
            try {

                UrViewModel.ViewUserDetailsName(false);
                UrViewModel.UserDetails(new UserDetailsModel({ UserId: 0, UserName: "", FirstName: "", LastName: "", EMailId: "", PrimaryRoleId: UrViewModel.RoleListOriginalForPrimary()[0].RoleId(), PrimaryRoleName: "", SecondaryRoleName: "", APName: "", IsActive: false, IsLocked: false, MobileNumber: "", IsSSOUsertext: 'No', IsSSOUser: false, IsADUser: false }));
                UrViewModel.UserDetails().MobileNumber("");
                UrViewModel.ManageUserActionsFlag(false);
                UrViewModel.EditUserDetails(true);
                UrViewModel.IseditUserName(false);
                UrViewModel.ManagementActionFlag(false);
                UrViewModel.AddUserFlag(true);
                document.getElementById('btnAddUpdate').innerHTML = "<i class='fa fa-check'></i>Create";
                $('#HeaderIcon').removeClass();
                $('#HeaderIcon').addClass('title-icon col-md-1 fa fa-plus');
                $('#frmUserDetails').find('input').get(0).autofocus = true;
                UrViewModel.ViewUserDetailsPopUpTitle('Create New User');
                $('#frmUserDetails').modal('show');
                setTimeout("$('#firstnameid').focus();", 200);
                $("#usernumberadd").intlTelInput({
                    allowExtensions: true,
                    autoFormat: false,
                    autoHideDialCode: false,
                    autoPlaceholder: false,
                    defaultCountry: "auto",
                    ipinfoToken: "yolo",
                    nationalMode: false,
                    numberType: "MOBILE",
                    preventInvalidNumbers: true,
                });
                UrViewModel.SelectedAssessmentPeriodMultiType([]);
                $("#AssessmentPeriodMultiSelect").multiselect();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClickAddUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function AddUser(data) {
            try {
                var Countrycode = "+" + $("#usernumberadd").intlTelInput("getSelectedCountryData").dialCode;
                var number = $("#usernumberadd").intlTelInput("getNumber");
                number = number.substring(Countrycode.length, number.length)
                if (number.length != 0) {
                    data.MobileNumber(Countrycode + "-" + number);
                }
                else {
                    data.MobileNumber("");
                }
                if (data.IsActive() === true)
                    data.IsActive(1);
                else data.IsActive(0);
                if (data.IsLocked() === true)
                    data.IsLocked(1);
                else data.IsLocked(0);

                var userType = 0;
                if (UrViewModel.IsSSOUser() == false && UrViewModel.IsADUser() == false) {
                    userType = 0;
                }
                else if (UrViewModel.IsSSOUser() == true && UrViewModel.IsADUser() == false) {
                    userType = 1;
                } else if (UrViewModel.IsSSOUser() == false && UrViewModel.IsADUser() == true) {
                    userType = 2;
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/Register",
                    type: "POST",
                    headers: headers,
                    data: ({
                        UserName: data.UserName(),
                        FirstName: data.FirstName(),
                        LastName: data.LastName(),
                        Email: data.EMailId(),
                        APName: UrViewModel.APNameObservable(),
                        PrimaryRoleID: data.PrimaryRoleId(),
                        SecondaryRoleID: data.SecondaryRoleId(),
                        IsUserLocked: data.IsLocked(),
                        MobileNumber: data.MobileNumber(),
                        IsSSOUser: UrViewModel.IsSSOUser(),
                        IsADUser: UrViewModel.IsADUser(),
                        UserType: userType
                    })
                })
                    .success(function (message) {
                        if (message == "User created successfully but Assessment Period details were not assigned.")
                            logger.logWarning('User created successfully but encountered issues while assigning Assessment Period details.', 'Warning', system.getModuleId(UrViewModel), true);
                        else
                            logger.logSuccess('User created successfully.', 'Success', system.getModuleId(UrViewModel), true);
                        GetUserDetails();

                        logger.logServer(message.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Server', system.getModuleId(UrViewModel), true);

                    })
                    .fail(function (error) {
                        if (error.status == 404 && error.responseText == '"User already exist."')
                            logger.logError(error.responseJSON.Message + ' - User with same email ID or username already exists.', 'Error', system.getModuleId(UrViewModel), true);
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: AddUser() method in UserRole.js';
                            logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);

                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in AddUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        //------------------------------------------------------------------------Logic to Add User Group Starts Here----------------------------------------------------------------------


        function onChnageofUserGroups(data, event) {
            try {

                var selection = event.currentTarget.value;
                for (var k = 1; k <= UrViewModel.BusinessLevelList().length; k++) {
                    $("#BLDrpDown_" + k).prop("disabled", true);
                }

                var array = []
                for (var i = 0; i < event.currentTarget.selectedOptions.length; i++) {
                    array.push(event.currentTarget.selectedOptions[i].innerText)
                }
                for (var j = 0; j < array.length; j++) {
                    for (var k = 0; k < UrViewModel.BusinessLevelList().length; k++) {
                        if (array[j] == UrViewModel.BusinessLevelList()[k].BlName()) {
                            var count = UrViewModel.BusinessLevelList()[k].Bulevel().replace(/^\D+/g, '');
                            $("#BLDrpDown_" + count).prop("disabled", false);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source onChnageofUserGroups() in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function AddUserGroup(data, event) {
            try {
                var organisationLevels = ko.observableArray();
                organisationLevels = UrViewModel.SelectedOrganisationLevel();
                //Organisational Level
                var selectedOrganisationLevels = ko.observableArray([]);
                var subLevels = ko.observableArray([]);
                var MappeedIdListTemp = [];
                for (var i = 0; i < UrViewModel.BusinessLevelList().length; i++) {
                    for (var j = 0; j < organisationLevels.length; j++) {
                        if (organisationLevels[j] == UrViewModel.BusinessLevelList()[i].BlId()) {
                            var id = parseInt(i) + 1;
                            selectedOrganisationLevels.push({ "BuId": organisationLevels[j], "BuName": UrViewModel.BusinessLevelList()[i].BlName(), "Bulevel": UrViewModel.BusinessLevelList()[i].Bulevel() });
                            for (var k = 0; k < (UrViewModel.BusinessLevelList()[i].BusinessLevelValueList().length); k++) {
                                if ($('#BLDrpDown_' + id).val() != "" && $('#BLDrpDown_' + id).val() == UrViewModel.BusinessLevelList()[i].BusinessLevelValueList()[k].BlvalueId()) {
                                    subLevels.push({ "BlvalueId": $('#BLDrpDown_' + id).val(), "BlvalueName": UrViewModel.BusinessLevelList()[i].BusinessLevelValueList()[k].BlvalueName(), "ParentBuLevel": UrViewModel.BusinessLevelList()[i].BlName(), "ParentBuLevelID": UrViewModel.BusinessLevelList()[i].BlId() });
                                    MappeedIdListTemp.push(parseInt($('#BLDrpDown_' + id).val()));
                                }

                            }

                        }

                    }
                }
                var matchcount = 0;
                for (var l = 0; l < UrViewModel.UserGroupList().length; l++) {
                    if (JSON.stringify(UrViewModel.UserGroupList()[l].mappedIdList()) == JSON.stringify(MappeedIdListTemp)) {
                        matchcount++;
                    }
                }
                if (matchcount != 0) {

                    $('#valUserGroupError').show();
                    $('#valUserGroupError').text("User Group with the same configuration already exists.");
                    return false;
                }
                else if (subLevels().length == 0) {

                    $('#valUserGroupError').show();
                    $('#valUserGroupError').text("Please choose the Sub-Organizational Levels.");
                    return false;

                }

                else {
                    $('#valUserGroupError').hide();
                    $('#valUserGroupError').text("");

                }


                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Configuration/AddUserGroup",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            OrganisationLevels: selectedOrganisationLevels(),
                            OrganisationSubLevels: subLevels()

                        })
                })
                    .success(function () {
                        logger.logSuccess('User group created successfully.', 'Success', system.getModuleId(UrViewModel), true);
                        $('#frmUserGroupDetails').modal('hide');
                        // GetUserGroups();
                    })
                    .fail(function (error) {
                        if (error.status == 404 && error.responseText == '"User Group exist."')
                            logger.logError('User group already exists.', 'Error', system.getModuleId(UrViewModel), true);
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: AddUser() method in UserRole.js';
                            logger.logMessage(msg);
                        }
                    });

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreateGroup() method in UserRole.js';
                logger.logMessage(msg);
            }
        }



        function ClickAddUserGroup(data, event) {
            try {
                GetAllBusinessLevels();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClickAddUserGroup() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function GetUserGroupsforUser(UserId) {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetUserGroupsforUser?UserId=" + UserId,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUserGroups() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    UrViewModel.ApplicableGroups([]);
                    if (jsonResult != null && jsonResult.length >= 0) {
                        for (var i = 0; i < jsonResult.length; i++) {
                            UrViewModel.ApplicableGroups().push(parseInt(jsonResult[i].UserGroupId));
                        }
                        UrViewModel.SelectedUserGroups(UrViewModel.ApplicableGroups());
                    }
                    else if (jsonResult.length == 0) {
                        logger.logWarning('User Groups arent configured for this year of assessment yet !', 'Success', system.getModuleId(UrViewModel), true)

                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUserGroups() method in UserRole.js';
                    logger.logMessage(msg);
                }

            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Fetch Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUserGroups() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUserGroups() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetUserGroups() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetUserGroups",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUserGroups() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null && jsonResult.length >= 0) {
                        var MappedUserGroupModelList = $.map(jsonResult, function (result) {
                            return new UserGroup(result);
                        });
                        UrViewModel.UserGroupList(MappedUserGroupModelList);

                    }
                    else if (jsonResult.length == 0) {
                        logger.logWarning('User Groups arent configured for this year of assessment yet !', 'Success', system.getModuleId(UrViewModel), true)

                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUserGroups() method in UserRole.js';
                    logger.logMessage(msg);
                }

            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Fetch Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUserGroups() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUserGroups() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }
        }


        //--------------------------------------------------------------------------

        function ConfigurationLevelModel(item) {
            try {
                var self = this;
                self.ConfigurationLevelID = ko.observable(item.Id);
                self.ConfigurationLevelName = ko.observable($('<div/>').html(item.Name).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in ValidationReports.js';
                logger.logMessage(msg);
            }
        }



        function GetAllBusinessLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getAllDistinctBusinessLevels",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllBusinessLevels() method in UserRole.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            return new BusinessLevelModel(result);
                        });
                        UrViewModel.BusinessLevelList(MappedBUModelList);
                        UrViewModel.BusinessLevelValueList([]);
                        UrViewModel.UserGroupDetails(new UserGroupModel({ ConfigurationLevel: MappedBUModelList, BusinessDivision: "", BusinessDivisionId: 0, LegalEntity: "", LegalEntityId: 0, Region: "", RegionId: 0, Country: "", CountryId: 0 }));

                        for (var i = 0; i < UrViewModel.BusinessLevelList().length; i++) {
                            var BLDropDownInPopUp = "";
                            var id = parseInt(i) + 1;
                            UrViewModel.BusinessLevelValueList(UrViewModel.BusinessLevelList()[i].BusinessLevelValueList());
                            BLDropDownInPopUp += '<div class="form-group">';
                            BLDropDownInPopUp += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + UrViewModel.BusinessLevelList()[i].BlName() + '</label>';
                            BLDropDownInPopUp += '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 ">';
                            BLDropDownInPopUp += '<select id="BLDrpDown_' + id + '" class="form-control" + " disabled="disabled">';
                            BLDropDownInPopUp += '<option value="" selected>Select</option>';
                            for (var k = 0; k < (UrViewModel.BusinessLevelList()[i].BusinessLevelValueList()).length; k++) {
                                BLDropDownInPopUp += '<option value="' + UrViewModel.BusinessLevelList()[i].BusinessLevelValueList()[k].BlvalueId() + '">' + UrViewModel.BusinessLevelList()[i].BusinessLevelValueList()[k].BlvalueName() + '</option>';
                            }
                            BLDropDownInPopUp += '</select>';
                            BLDropDownInPopUp += '</div>';
                            BLDropDownInPopUp += '</div>';
                            $('#AddBusinessLevel').append(BLDropDownInPopUp);
                        }

                        $('#HeaderUserGroupIcon').removeClass();
                        $('#HeaderUserGroupIcon').addClass('title-icon col-md-1 fa fa-plus');
                        UrViewModel.SelectedOrganisationLevel([]);
                        UrViewModel.ViewUserGroupDetailsPopUpTitle('Create New User Group');
                        $('#frmUserGroupDetails').modal('show')
                        setTimeout("$('#ConfigurationSelection').multiselect()", 200);
                        $(".ui-multiselect-checkboxes > li > input").on("onchange", onChnageofUserGroups);

                        $($(document.getElementsByClassName('list-group-item')).get(0)).addClass('active');
                        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(0)).addClass('active');

                    }
                }

                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllBusinessLevels() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Add Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessLevels() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessLevels() method in UserRole.js';
                    logger.logMessage(msg);
                }
            };
        }






        //------------------------------------------------------------------------Logic to Add User Details Ends Here----------------------------------------------------------------------

        //------------------------------------------------------------------------Logic to Manage User Action Starts Here----------------------------------------------------------------------
        function ManageUserActions(data, event) {
            try {
                UrViewModel.ManageUserActionsFlag(true);
                UrViewModel.Usergroupselectlabel("Select User Groups:")
                UrViewModel.SelectedUserGroups(data.UserGroupIdList())
                var LastLoginDate = data.LastLoginDate();
                UrViewModel.IseditUserName(true);
                data = SyncUserDetails(data);
                data.LastLoginDate(LastLoginDate);
                (data.PrimaryRoleId() == 0) ? data.PrimaryRoleName("Not Applicable") : data.PrimaryRoleName();
                (data.SecondaryRoleId() == 0) ? data.SecondaryRoleName("Not Applicable") : data.SecondaryRoleName();
                UrViewModel.UserDetails(data);
                UrViewModel.EditUserDetails(false);
                UrViewModel.ManagementActionFlag(true);
                UrViewModel.AddUserFlag(true);

                //Logic to Develop the Actions List
                UrViewModel.ActionsList([]);
                $('#ViewuserGroupDetailsId').hide();
                var Option = UrViewModel.ActionsMasterList()[0];
                UrViewModel.ActionsList.push(Option);

                    //UrViewModel.ActionsList.push(UrViewModel.ActionsMasterList()[6]);     [6] in UrViewModel.ActionsMasterList() contains the option 'Assign/Unassign user group' and the
                                                                                            //functionality related to User Group can be performed from User Group Managemnt screen.
                                                                                            //Hence commenting the line of code as we do not require the option anymore.


                if (!data.IsActive()) {
                    Option = "";
                    Option = UrViewModel.ActionsMasterList()[1];
                    UrViewModel.ActionsList.push(Option);
                }
                else {
                    Option = "";
                    Option = UrViewModel.ActionsMasterList()[2];
                    UrViewModel.ActionsList.push(Option);
                    if (data.IsLocked()) {
                        Option = UrViewModel.ActionsMasterList()[4];
                        UrViewModel.ActionsList.push(Option);
                    }
                    else {
                        Option = UrViewModel.ActionsMasterList()[3];
                        UrViewModel.ActionsList.push(Option);
                    }
                    Option = UrViewModel.ActionsMasterList()[5];
                    UrViewModel.ActionsList.push(Option);
                }

                UrViewModel.SelectedActionValue(UrViewModel.ActionsMasterList()[0]);

                $('#HeaderIcon').removeClass();
                $('#HeaderIcon').addClass('title-icon col-md-1 fa fa-user');
                UrViewModel.ViewUserDetailsPopUpTitle('Manage Actions - ' + data.UserName());
                $('#UserGroup').multiselect();
                UrViewModel.ManageUserActionsFlag(false);
                ResetActionValuetoDefault();
                $('#frmActionOperations').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ManageUserActions() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function PerformUserAction(data, event) {
            try {
                $('#validationError').text("");
                var errorcount = 0;

                if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 0) {
                    $('#validationError').text("Please select an action to perform.");
                    errorcount++;
                    $('#validationError').show();
                }

                if (errorcount == 0) {
                    if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 0)
                        $('#validationError').text("Please select an action to perform.");
                    else if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 6) {

                        }
                    else if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 1)
                        ActivateUser(data, event);
                    else if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 2)
                        DeactivateUser(data, event);
                    else if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 3)
                        LockUser(data, event);
                    else if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 4)
                        UnlockUser(data, event);
                    else if (UrViewModel.ActionsMasterList.indexOf(UrViewModel.SelectedActionValue()) == 5)
                        ResetPassword(data, event);
                    $('#frmActionOperations').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }

                ResetActionValue();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PerformUserAction() method in UserRole.js';
                logger.logMessage(msg);
            }
        }




        function ResetActionValue() {
            // UrViewModel.ActionsList([]);
            UrViewModel.SelectedActionValue("----Select an Action for this User----");
        }
        function ResetActionValuetoDefault() {
            UrViewModel.SelectedActionValue("----Select an Action for this User----");
        }

        function ActivateUser(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/ActivateUser",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            userName: data.UserName()
                        })
                })
                    .success(function (jsonResult, error) {
                        GetUserDetails();
                        if (jsonResult == "User activation link was sent successfully but Assessment Period details were not mapped.") {
                            logger.logSuccess('User activated successfully. An activation E-mail has been sent to the user.', 'Success', system.getModuleId(UrViewModel), true);
                            logger.logWarning('Assessment Period details could not be mapped.', 'Warning', system.getModuleId(UrViewModel), true);
                        }
                        else {
                            logger.logSuccess('User activated successfully. An activation E-mail has been sent to the user. Assessment Period details mapped successfully.', 'Success', system.getModuleId(UrViewModel), true);
                            //logger.logSuccess('Assessment Period details mapped successfully.', 'Success', system.getModuleId(UrViewModel), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ActivateUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function DeactivateUser(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/DeactivateUser",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            userName: data.UserName()
                        })
                })
                    .success(function (jsonResult, error) {
                        GetUserDetails();
                        logger.logSuccess('User deactivated successfully. An E-mail has been sent to the user informing the same.', 'Success', system.getModuleId(UrViewModel), true);
                    })
                    .fail(function (error, status) {
                        logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeactivateUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function LockUser(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/LockUser",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            userName: data.UserName()
                        })
                })
                    .success(function (jsonResult, error) {
                        GetUserDetails();
                        logger.logSuccess('User has been locked successfully.', 'Success', system.getModuleId(UrViewModel), true);
                    })
                    .fail(function (error, status) {
                        logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in LockUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function UnlockUser(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/UnlockUser",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            userName: data.UserName()
                        })
                })
                    .success(function (jsonResult, error) {
                        GetUserDetails();
                        logger.logSuccess('User has been unlocked successfully.', 'Success', system.getModuleId(UrViewModel), true);
                    })
                    .fail(function (error, status) {
                        logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UnlockUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function ResetPassword(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/ResetPassword",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            userName: data.UserName()
                        })
                })
                    .success(function () {
                        logger.logSuccess('User\'s password has been reset successfully. An E-mail has been sent to the user informing the same.', 'Success', system.getModuleId(UrViewModel), true);
                    })
                    .fail(function (error) {
                        logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ResetPassword() method in UserRole.js';
                logger.logMessage(msg);
            }
        }
        //------------------------------------------------------------------------Logic to Manage User group starts Here----------------------------------------------------------------------

        function AssignUnassignUserGroups(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/AddUpdateUserGroups",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify
                        ({
                            UserGroupIdList: UrViewModel.SelectedUserGroups(),
                            UserId: data.UserId()
                        })
                })
                    .success(function () {
                        logger.logSuccess('User\'s User Group mapping has been saved successfully.', 'Success', system.getModuleId(UrViewModel), true);
                        // GetUserDetails();
                    })
                    .fail(function (error) {
                        logger.logError(error.responseJSON.Message + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ResetPassword() method in UserRole.js';
                logger.logMessage(msg);
            }
        }
        //------------------------------------------------------------------------Logic to Manage User group ends Here----------------------------------------------------------------------

        //-------------------------------------------------------------------------Logic to ViewUserGroupDetails Starts here----------------------------------------------------------------------
        function viewUserGroupDetails() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetUserGroupDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        var mappedUserGroupDetails = $.map(jsonResult, function (result) {
                            return new UserGroup(result);
                        });
                        UrViewModel.ViewUserGroupDetailsList([]);
                        UrViewModel.ViewUserGroupDetailsList(mappedUserGroupDetails)
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(UrViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in LockUser() method in UserRole.js';
                logger.logMessage(msg);
            }
        }
        //-------------------------------------------------------------------------Logic to viewUserGroupDetails ends here-------------------------------------------------------------------
        function CancelUserDetailsPopup() {
            try {
                ResetActionValuetoDefault();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in CancelUserDetailsPopup() method in UserRole.js';
                logger.logMessage(msg);
            }
        }


        function ChangedSSO(data, event) {
            try {
                //Toggle the flag
                document.getElementById(event.currentTarget.id).checked = true;
                if (event.currentTarget.value == "NoFactor") {
                    UrViewModel.IsADUser(false);
                    UrViewModel.IsSSOUser(false);
                    $("#NoChkFactor").prop("checked", true);
                    $("#YesChkFactor").prop("checked", false);
                    $("#YesADFactor").prop("checked", false);
                }
                else if (event.currentTarget.value == "YesFactor") {
                    UrViewModel.IsSSOUser(true);
                    UrViewModel.IsADUser(false);
                    $("#NoChkFactor").prop("checked", false);
                    $("#YesChkFactor").prop("checked", true);
                    $("#YesADFactor").prop("checked", false);
                }
                else {
                    UrViewModel.IsADUser(true);
                    UrViewModel.IsSSOUser(false);
                    $("#NoChkFactor").prop("checked", false);
                    $("#YesChkFactor").prop("checked", false);
                    $("#YesADFactor").prop("checked", true);
                }
                return true;

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveResponseType() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
        }

        //------------------------------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------------

        function UserDetailsModel(item) {
            try {
                var self = this;
                var LocalDate = new Date($('<div/>').html(item.LastLoginDate).text() + " UTC");
                self.UserId = ko.observable(item.UserId);
                self.UserName = ko.observable($('<div/>').html(item.UserName).text());
                self.FirstName = ko.observable($('<div/>').html(item.FirstName).text());
                self.LastName = ko.observable($('<div/>').html(item.LastName).text());
                self.EMailId = ko.observable($('<div/>').html(item.EMailId).text());
                self.LastLoginDate = ko.observable((LocalDate.toDateString() == "Mon Jan 01 1900" || LocalDate.toDateString() == "Invalid Date") ? "Not Yet Logged-In" : LocalDate.toDateString() + ', ' + LocalDate.toLocaleTimeString());
                self.PrimaryRoleId = ko.observable(item.PrimaryRoleId);
                self.PrimaryRoleName = ko.observable(($('<div/>').html(item.PrimaryRoleName).text() == "") ? "Not Applicable" : $('<div/>').html(item.PrimaryRoleName).text());
                self.SecondaryRoleId = ko.observable(item.SecondaryRoleId);
                self.SecondaryRoleName = ko.observable(($('<div/>').html(item.SecondaryRoleName).text() == "") ? "Not Applicable" : $('<div/>').html(item.SecondaryRoleName).text());
                self.APId = ko.observable(($('<div/>').html(item.APId).text() == "") ? "Not Applicable" : $('<div/>').html(item.APId).text());
                self.APName = ko.observable(($('<div/>').html(item.APName).text() == "") ? "Not Applicable" : $('<div/>').html(item.APName).text());
                self.IsActive = ko.observable(item.IsActive);
                self.IsLocked = ko.observable(item.IsLocked);
                self.IsSSOUsertext = ko.observable(item.IsSSOUser == true ? 'Yes' : 'No');
                self.IsSSOUser = ko.observable(item.IsSSOUser);
                self.IsADUser = ko.observable(item.IsADUser);

                if (item.IsSSOUser == false && item.IsADUser == false) {
                    $("#NoChkFactor").prop("checked", true);
                    $("#YesChkFactor").prop("checked", false);
                    $("#YesADFactor").prop("checked", false);
                }
                else if (item.IsSSOUser == true && item.IsADUser == false) {
                    $("#NoChkFactor").prop("checked", false);
                    $("#YesChkFactor").prop("checked", true);
                    $("#YesADFactor").prop("checked", false);
                }
                else if (item.IsADUser == true) {
                    $("#NoChkFactor").prop("checked", false);
                    $("#YesChkFactor").prop("checked", false);
                    $("#YesADFactor").prop("checked", true);
                }

                UrViewModel.IsSSOUser(item.IsSSOUser);
                UrViewModel.IsADUser(item.IsADUser);
                self.UserGroups = ko.observableArray(UrViewModel.UserGroupList());
                self.SelectedUserGroups = ko.observableArray(UrViewModel.SelectedUserGroups());
                self.IsSelected = ko.observable(false);
                self.print = ko.observable();
                self.UserGroupIdList = ko.observable(item.UserGroupIdList)
                if (item.MobileNumber == null || item.MobileNumber.length == 0) {
                    self.MobileNumber = ko.observable('Not Available');
                }
                else {
                    self.MobileNumber = ko.observable(item.MobileNumber);
                }
                self.Status = ko.computed(function () {
                    var Result = "";
                    if (!self.IsActive())
                        Result = "Inactive";
                    else if (self.IsActive() && self.IsLocked())
                        Result = "Locked";
                    else if (self.IsActive())
                        Result = "Active";
                    else
                        Result = "Not Available";
                    return Result;
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserDetailsModel() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function UserGroupModel(item) {
            try {
                var self = this;

                self.ConfigurationLevel = ko.observableArray(item.ConfigurationLevel);
                self.BusinessDivision = ko.observable($('<div/>').html(item.BusinessDivision).text());
                self.BusinessDivisionId = ko.observable(item.BusinessDivisionId);
                self.LegalEntity = ko.observable($('<div/>').html(item.LegalEntity).text());
                self.LegalEntityId = ko.observable(item.LegalEntityId);
                self.Region = ko.observable($('<div/>').html(item.Region).text());
                self.RegionId = ko.observable(item.RegionId);
                self.Country = ko.observable($('<div/>').html(item.Country).text());
                self.CountryId = ko.observable(item.CountryId);
                self.IsActive = ko.observable(item.IsActive);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserGroupModel() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function UserGroup(item) {
            try {
                var self = this;
                self.UserGroupName = item.UserGroupName;
                self.UserGroupId = item.UserGroupId;
                self.OrgLevelName = ko.observable(item.OrgLevelName);
                self.SubOrglevelName = ko.observable(item.SubOrglevelName);
                self.mappedIdList = ko.observable(item.MappedUserGroupList);
                self.OrganisationLevels = item.OrganisationLevels;
                self.OrganisationSubLevels = item.OrganisationSubLevels;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserGroup() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function RoleModel(item) {
            try {
                var self = this;
                self.RoleId = ko.observable(item.RoleId);
                self.RoleName = ko.observable($('<div/>').html(item.RoleName).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RoleModel() method in UserRole.js';
                logger.logMessage(msg);
            }
        }
        function CancelPopup() {
            try {
                $('#ExportexcelUsserrole').modal('hide');
                UrViewModel.popUpTitle('');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CancelPopup() method in UserRole.js';
                logger.logMessage(msg);
            }
        }
        function OpenSelectFilePopUp() {
            try {
                UrViewModel.popUpTitle('Choose File')
                $('#ExportexcelUsserrole').modal('show');
                $('#valfactorerror').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OpenSelectFilePopUp() method in UserRole.js';
                logger.logMessage(msg);
            }
        }
        function uploadBulkUserTemplate() {
            try {
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                    ) {
                        if (FileList[0].size <= 1073741824) {

                            document.getElementById('valfactorerror').innerHTML = "";

                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function (data) {
                                if (request.readyState == 1) {
                                    document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                    $('#valfactorerror').show();
                                }
                                else if (request.readyState == 4) {
                                    if (request.status == 200) {
                                        if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                            document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                            $('#valfactorerror').show();
                                            var DocName = document.getElementById('FileUploader').files[0].name;
                                            document.getElementById('FileUploader').value = null;
                                            $('#Exportexcel').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();
                                            UrViewModel.successfullyCreatedUserList(JSON.parse(request.responseText));
                                            GetUserDetails();
                                            FailedUsersPopup();
                                        }
                                        else {
                                            document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                            logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(UrViewModel), true);
                                            $('#valfactorerror').show();
                                            document.getElementById('FileUploader').value = null;
                                            $('#Exportexcel').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();

                                        }
                                    }
                                    else
                                        ajaxFail(request, "");
                                }
                            };
                            request.upload.addEventListener('progress', function (event) {
                                document.getElementById('valfactorerror').innerHTML = "Uploading File...";

                            });
                            request.withCredentials = true;
                            request.open('POST', "/api/Account/ImportExcelBulkUserActivation");
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);

                        }
                        else
                            document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed " + (SrViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                    }
                    else
                        document.getElementById('valfactorerror').innerHTML = "Please Select Valid File to Upload";
                }

                else
                    document.getElementById('valfactorerror').innerHTML = "Please Select a File to Upload";
                $('#valfactorerror').show();

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadBulkUserTemplate() method in UserRole.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadBulkUserTemplate() method in UserRole.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadBulkUserTemplate() method in UserRole.js';
                logger.logMessage(msg);
            }
        }

        function ActionChanged(data, event) {
            try {

                UrViewModel.ManageUserActionsFlag(false);
                if (UrViewModel.SelectedActionValue() == "Assign/Unassign user group" & UrViewModel.UserGroupList().length > 0) {
                    UrViewModel.ManageUserActionsFlag(true);
                    $('#UserGroup').multiselect({});
                }
                else if (UrViewModel.UserGroupList().length == 0 & UrViewModel.SelectedActionValue() == "Assign/Unassign user group") {
                    document.getElementById('valError').innerHTML = 'User Groups aren\'t configured for this year of assessment yet.'
                    $('#valError').show();
                }
                else {
                    $('#valError').hide();
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in UserRole.js';
                logger.logMessage(msg);
            }
        }


        //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

    });

function FaiedUserDetailsModel(item) {
    try {
        var self = this;

        self.EmailID = ko.observable($('<div/>').html(item.EmailID).text());

    }

    catch (e) {
        var msg = 'Exception: ' + e + ' | Source:FaiedUserDetailsModel() method in UserRole.js';
        logger.logMessage(msg);
    }
}
function FailedUsersPopup() {
    try {
        $('#BulkUsersPopup').modal('show');
    }
    catch (e) {
        var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetDateOffAssessment() method in AmlInherentRiskAssessment.js';
    }
}

function AssessmentPeriodModel(item) {
    try {
        var self = this;
        self.AssessmentPeriodId = ko.observable(item.ProfileId);
        self.AssessmentPeriodName = ko.observable(item.Profilename);
    }
    catch (e) {
        var msg = 'Exception: ' + e + ' | Source: AssessmentPeriodModel() method in ConfigureActionTracker.js';
        logger.logMessage(msg);
    }
}
;
